import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";

const readConsent = () => {
  try {
    return JSON.parse(localStorage.getItem("sisal-cookie-consent"))?.thirdParty === true;
  } catch {
    return false;
  }
};

export default function MapEmbed({ query, label }) {
  const [consented, setConsented] = useState(readConsent);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    const handler = () => setConsented(readConsent());
    window.addEventListener("cookie-consent-updated", handler);
    return () => window.removeEventListener("cookie-consent-updated", handler);
  }, []);

  const show = consented || clicked;
  const src = `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=16&output=embed`;

  if (!show) {
    return (
      <div className="flex h-72 flex-col items-center justify-center gap-4 rounded-3xl border border-dashed border-slate-200 bg-slate-50 p-6 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-light text-brand-dark">
          <MapPin className="h-6 w-6" />
        </span>
        <p className="max-w-xs text-sm text-slate-500">
          La mappa è fornita da Google Maps e viene caricata solo con il tuo consenso.
        </p>
        <button
          data-testid={`map-load-${label}`}
          onClick={() => setClicked(true)}
          className="btn btn-outline btn-md"
        >
          MOSTRA LA MAPPA
        </button>
      </div>
    );
  }

  return (
    <iframe
      data-testid={`map-iframe-${label}`}
      title={`Mappa — ${label}`}
      src={src}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      className="h-72 w-full rounded-3xl border border-slate-100"
      allowFullScreen
    />
  );
}
